import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Router } from '@angular/router';
// import { ApiService } from 'src/app/services/api.service';
import { DialogService } from 'src/app/services/dialog.service';
import { UserService } from 'src/app/services/user.service';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { GlobalService } from 'src/app/services/global.service';
import { DistributionApiService } from 'src/app/distribution/distribution-api.service';
import { ExitGuard } from 'src/app/exit-popup.guard';



@Component({
  selector: 'sd-exit-pop-up',
  templateUrl: './exit-pop-up.component.html',
  styleUrls: ['./exit-pop-up.component.scss']
})
export class ExitPopUpComponent implements OnInit {

  userId;
  adsLoaded: Boolean;
  showPopup: Boolean;
  loginDialogRef: MatDialogRef<LoginDialogComponent>
  constructor(
    // private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ExitPopUpComponent>,
    // private router: Router,
    // private dialog: DialogService,
    private userService: UserService,
    public global: GlobalService,
    private api: DistributionApiService
  ) { }

  ngOnInit(): void {
    this.userId = this.userService.id

  }

  closePopup() {
    this.dialogRef.close()
  };

  // // Getting Email
  // signup(form: NgForm) {
  //   this.global.trackEvent('Exit-pop-up', 'Signup-dialog-open', form.value['email'])
  //   this.loginDialogRef = this.matDialog.open(LoginDialogComponent, {
  //     data: {
  //       email: form.value['email'],
  //       tab: 2,
  //       type: 'ref-',
  //       from: 'exit-pop'
  //     },

  //   });

  //   this.closePopup()
  // };

  // Open PopUp in different URL



  // Submit Mobile Number

  submitNumber(value) {

    if (this.data.ftype == "Distribution"){
         this.api.exitPopupTracker(value.email, 'distribution_exit_popup', this.userId).subscribe(res => {
          if (res.message == 'success') {
            // this.global.setCookie('distExitPopup', 'true', 180)
            this.global.setCookie('distExitPopup', 'true', 180)
          }
        })
    } else {
        this.api.exitPopupTracker(value.email, 'subscription_exit_popup', this.userId).subscribe(res => {
          if (res.message == 'success') {
            // this.global.setCookie('distExitPopup', 'true', 180)
            this.global.setCookie('subsExitPopup', 'true', 180)
          }
        })
  }

    this.closePopup()


  }

}
